// Simple role strategy: treat configured emails as admins, others as users
const adminList = (process.env["REACT_APP_ADMIN_EMAILS"] || "")
  .split(",")
  .map((e) => e.trim().toLowerCase())
  .filter(Boolean);

export function isAdminEmail(email: string | null | undefined): boolean {
  if (!email) return false;
  return adminList.includes(email.toLowerCase());
}


